import React from "react";
import * as Icons from "lucide-react";
import { SERVICES } from "@/constants/testIds";
import { SERVICES_LIST } from "@/data/siteData";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Services() {
  return (
    <section id="services" data-testid={SERVICES.root} className="pe-section bg-[var(--pe-black)]">
      <div className="container-pe">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="pe-eyebrow mb-5">What We Do</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1] tracking-wide">
            EVERY CIRCUIT.
            <br />
            <span className="text-[var(--pe-gold)]">EVERY SCALE.</span>
          </h2>
          <p className="mt-6 text-[var(--pe-muted)] text-base md:text-lg max-w-2xl">
            Residential, commercial, EV, emergency — there isn't much we
            haven't wired. Pick a category below or jump straight to the
            quote form and tell us what you need.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES_LIST.map((s) => {
            const Icon = Icons[s.icon] || Icons.Zap;
            return (
              <article
                key={s.slug}
                className="pe-card group"
                data-testid={SERVICES.card(s.slug)}
              >
                <div className="flex items-start justify-between">
                  <div className="h-11 w-11 rounded-sm border border-[var(--pe-line-strong)] bg-[var(--pe-ink)] grid place-items-center text-[var(--pe-gold)] group-hover:text-[var(--pe-blue)] transition-colors">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--pe-muted)]">
                    {String(SERVICES_LIST.indexOf(s) + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display text-2xl mt-6 text-white tracking-wide">
                  {s.title.toUpperCase()}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--pe-muted)]">
                  {s.blurb}
                </p>
                <div className="mt-6 pt-5 border-t border-[var(--pe-line)] flex items-center justify-between">
                  <a
                    href="#quote"
                    onClick={scrollTo("quote")}
                    className="font-mono text-[11px] tracking-[0.24em] uppercase text-[var(--pe-gold)] hover:text-white transition-colors inline-flex items-center gap-2"
                  >
                    Get a Quote
                    <Icons.ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                  {s.slug === "emergency" ? (
                    <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--pe-blue)]">
                      Not Guaranteed
                    </span>
                  ) : null}
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-10 pe-card bg-[var(--pe-ink)] flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p className="text-sm md:text-base text-[var(--pe-muted)]">
            Don't see what you need listed? If it has voltage running
            through it, chances are we do it.
          </p>
          <a
            href="#quote"
            onClick={scrollTo("quote")}
            className="pe-btn pe-btn-primary self-start md:self-auto"
          >
            <Icons.MessageSquare className="h-4 w-4" />
            Tell Us About Your Job
          </a>
        </div>
      </div>
    </section>
  );
}
